<template>
    <span>Redirecting...</span>
</template>

<script>
export default ({
  created() {
    window.location.href = `${process.env.VUE_APP_WEBAPP_BASE_URL}/trainers`;
  },
});
</script>
